// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"styles_outerContainer__3QZAm","innerContainer":"styles_innerContainer__wLbxB","detail":"styles_detail__1Uozr","detailIcon":"styles_detailIcon__2aabh"};